import React from "react";
import "./DeliveryTermsConditions.css";
import './DeliveryTermsConditions.css';

const DeliveryTermsConditions = () => {
  return (
    <div className="terms-container">
      <div className="terms-header">
        <h1>Terms & Conditions (Delivery Partner)</h1>
      </div>

      <div className="terms-content">
        <p className="updated-date">Effective Date: November 2025</p>

        <section>
          <h2>1. Agreement Overview</h2>
          <p>
            By registering and working as a Delivery Partner with
            <strong> RismicMart Pvt. Ltd.</strong> (“Company”, “We”, “Us”),
            you agree to abide by these Terms & Conditions. These govern your
            engagement, responsibilities, conduct, and payments as part of the
            RismicMart delivery system.
          </p>
        </section>

        <section>
          <h2>2. Eligibility</h2>
          <ul>
            <li>You must be at least 18 years old.</li>
            <li>You must have a valid driving license and vehicle documents.</li>
            <li>
              You must possess a smartphone with GPS and active internet access.
            </li>
          </ul>
        </section>

        <section>
          <h2>3. Working Hours</h2>
          <p>
            Working hours are <strong>6:00 AM – 10:00 PM</strong> for male
            partners and <strong>10:00 AM – 6:00 PM</strong> for female
            partners. Timings may vary depending on operational needs.
          </p>
        </section>

        <section>
          <h2>4. Earnings & Payment</h2>
          <p>
            Earnings will be provided on a <strong>daily or monthly basis</strong> as per company policy.
            Payment depends on completed deliveries and performance, and will be credited digitally or by bank transfer.
          </p>
        </section>

        <section>
          <h2>5. Delivery Equipment</h2>
          <p>
            Official delivery <strong>bags and uniforms</strong> will be provided by RismicMart Pvt. Ltd. These must be
            used only for deliveries and kept in good condition.
          </p>
        </section>

        <section>
          <h2>6. Insurance & Safety</h2>
          <p>
            Currently, only <strong>accidental and limited medical coverage</strong> may be provided.
            Partners are encouraged to maintain their own health and vehicle insurance.
          </p>
        </section>

        <section>
          <h2>7. Partner Conduct</h2>
          <p>
            Delivery partners must maintain professionalism and respectful
            behavior with customers. Any misconduct or negligence may lead to
            suspension or termination.
          </p>
        </section>

        <section>
          <h2>8. Attendance & Availability</h2>
          <p>
            Partners must mark their <strong>availability accurately</strong> in the system.
            Frequent absenteeism without notice can lead to account deactivation.
          </p>
        </section>

        <section>
          <h2>9. Confidentiality</h2>
          <p>
            All partner and customer data is confidential. Sharing or misuse of
            personal or order-related information is strictly prohibited.
          </p>
        </section>

        <section>
          <h2>10. Termination</h2>
          <p>
            The company may suspend or terminate a partner’s service for policy
            violations, misconduct, or fraudulent activities.
          </p>
        </section>

        <section>
          <h2>11. Vehicle & License Responsibility</h2>
          <p>
            The partner is responsible for maintaining valid licenses and
            documents. RismicMart will not be liable for traffic fines or legal
            actions.
          </p>
        </section>

        <section>
          <h2>12. Device & App Usage</h2>
          <p>
            Partners must use their own smartphones with an active internet
            connection. The company is not responsible for any device issues or
            mobile data costs.
          </p>
        </section>

        <section>
          <h2>13. Safety & Legal Compliance</h2>
          <p>
            Partners must always follow traffic laws and wear helmets or
            protective gear. Negligence resulting in accidents is the partner’s
            own responsibility.
          </p>
        </section>

        <section>
          <h2>14. Customer Interaction</h2>
          <p>
            Maintain polite communication with customers at all times. Report
            any disputes immediately to RismicMart Support.
          </p>
        </section>

        <section>
          <h2>15. Dispute Resolution</h2>
          <p>
            Disputes between delivery partners and the company will be resolved
            through internal review or arbitration, as per company policy.
          </p>
        </section>

        <section>
          <h2>16. Modification of Terms</h2>
          <p>
            RismicMart Pvt. Ltd. reserves the right to modify or update these
            Terms & Conditions anytime. Partners will be notified via the app or
            official communication channels.
          </p>
        </section>

        <section className="acknowledgment">
          <h2>Acknowledgment</h2>
          <p>
            By continuing to deliver for RismicMart Pvt. Ltd., you acknowledge
            that you have read, understood, and agreed to these Terms &
            Conditions.
          </p>
        </section>

        <div className="company-info">
          <p>
            <strong>RismicMart Pvt. Ltd.</strong>
            <br />
            Corporate Office: [CN 8/2, Sidco Global Tower, Sector V, Kolkata]
            <br />
            Email: rismicmartpvtltd@gmail.com
            <br />
            Website:{" "}
            <a href="https://www.rismicmart.com" target="_blank" rel="noreferrer">
              www.rismicmart.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default DeliveryTermsConditions;